export default (target, key, descriptor) => {
  const modifier = descriptor.value;

  descriptor.value = function() {
    return this.enqueue(modifier.apply(this, arguments));
  };

  return descriptor;
};



// WEBPACK FOOTER //
// ./src/core/presenter/vm-modifier.js